<select class="form-control" [disabled] = "DisableComboBox" [attr.name]="ComboBoxName" (change)="ComboBoxChanged()"   >
    <option [value]="ComboBoxOptionalValue">{{ComboBoxOptionalName}}</option>
    <option *ngFor="let data of dataArray" [value]="data.Value" [selected]="(data.Name == ComboBoxSelectedValue || data.Value == ComboBoxSelectedValue ) ">{{data.Name}}</option>
</select>